import { useEffect } from 'react';
import { useSidebar } from '@css-xp/base';
import { COMMON_SIDEBARS } from '@css-xp/ppc-constants';
import { ShipToPartySidebar } from '@css-xp/ppc-ship-to-party-sidebar';

const partnerAllowedCommonSidebars = {
  [COMMON_SIDEBARS.ADD_CUSTOMER]: ShipToPartySidebar,
};

/**
 * This method is used to include partner common sidebars and common sidebars will add on to specific page sidebars like Home, Invoice, Subscription and Customers.
 * Usually we add sidebars on passing props to the components AppPage with allowedSidebars.
 * But If we want to add common sidebars along with specific page sidebars then we have to add common sidebar on each pages with allowedSidebars.
 * Calling common sidebar on each specific page is not a better way. AppPage has already globalAllowedSidebars for common sidebars.
 * But we have to keep our all PPC common sidebars inside @css-xp/base.
 */
export function usePartnerCommonSidebars() {
  const { addToAllowlistSidebars, closeSidebar, clearSidebars } = useSidebar();

  useEffect(() => {
    addToAllowlistSidebars(partnerAllowedCommonSidebars);

    return () => {
      closeSidebar();
      clearSidebars();
    };
  }, [addToAllowlistSidebars, closeSidebar, clearSidebars]);
}
